import { DeliveryTemplate } from "@/services/backend/delivery-templates/delivery";
import { useListDeliveryTemplatesQuery } from "@/services/backend/delivery-templates/service";
import {
  DataTable,
  DataTableContainer,
  useDataTableController,
} from "@/shared/components/data-table";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import { ColumnDef } from "@tanstack/react-table";
import { DeliveryTemplateModal } from "./delivery-template-modal";

interface DeliveryTemplatesListTableProps {
  customerId: string;
}

const createTableColumns = (
  customerId: string,
): ColumnDef<DeliveryTemplate>[] => [
  {
    id: "templateDescription",
    accessorKey: "templateDescription",
    header: "Beschreibung",
    cell: ({ row }) => row.original.templateDescription,
  },
  {
    id: "templateId",
    accessorKey: "templateId",
    header: "Details",
    cell: ({ row }) => (
      <DeliveryTemplateModal
        templateId={row.original.templateId}
        customerId={customerId}
        buttonLabel="Vorlage bearbeiten"
      />
    ),
  },
];

export function DeliveryTemplatesListTable({
  customerId,
}: DeliveryTemplatesListTableProps) {
  const {
    data: templateData,
    error,
    isLoading,
    isFetching,
  } = useListDeliveryTemplatesQuery({
    customerId: {
      active: true,
      values: [customerId as string],
    },
    limit: 0,
    offset: 0,
  });

  const tableColumns = createTableColumns(customerId);
  const table = useDataTableController(tableColumns, templateData?.items || []);

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <DataTableContainer>
      <DataTable
        table={table}
        columns={tableColumns}
        isLoading={isLoading || isFetching}
      />
    </DataTableContainer>
  );
}
